import {
  RugComponentStats,
  RugComponentStatsRaw,
  RugSectionMinimum,
  RugSectionMinimumRaw,
  RugSectionStats,
  RugSectionStatsRaw,
} from 'pages/reporting/reports/rug/types'
import {
  GeckoComponentCoords,
  GeckoMeasurement,
  GeckoMeasurementUnit,
} from 'types'

import { sectionFromRaw, sectionToRaw } from './sectionable'

export function serializeRUGSectionMinimum(
  minimum: RugSectionMinimum
): RugSectionMinimumRaw {
  return {
    thickness: minimum.thickness.toJSON(),
    location: {
      x: minimum.location.x.num,
      y: minimum.location.y.num,
      xUnit: minimum.location.x.unit.id,
      yUnit: minimum.location.y.unit.id,
      componentID: minimum.location.componentID,
    },
  }
}

export function deserializeRUGSectionMinimum(
  minimumRaw: RugSectionMinimumRaw
): RugSectionMinimum {
  return {
    thickness: GeckoMeasurement.CreateFromJSON(minimumRaw.thickness),
    location: GeckoComponentCoords.CreateFromValues(
      minimumRaw.location.componentID,
      minimumRaw.location.x,
      GeckoMeasurementUnit.GetOrCreate(minimumRaw.location.xUnit),
      minimumRaw.location.y,
      GeckoMeasurementUnit.GetOrCreate(minimumRaw.location.yUnit)
    ),
  }
}

export function serializeRUGComponentStats(
  stats: RugComponentStats
): RugComponentStatsRaw {
  return {
    minThicknesses: stats.minThicknesses.map((minimum) => {
      return serializeRUGSectionMinimum(minimum)
    }),
    averageThickness: stats.averageThickness.toJSON(),
    tMin: stats.tMin?.toJSON(),
    nominalThickness: stats.nominalThickness?.toJSON(),
    maxWallLossPercent: stats.maxWallLossPercent?.toJSON(),
  }
}

export function deserializeRUGComponentStats(
  statsRaw: RugComponentStatsRaw
): RugComponentStats {
  return {
    minThicknesses: statsRaw.minThicknesses.map((minimum) => {
      return deserializeRUGSectionMinimum(minimum)
    }),
    averageThickness: GeckoMeasurement.CreateFromJSON(
      statsRaw.averageThickness
    ),
    tMin: statsRaw.tMin
      ? GeckoMeasurement.CreateFromJSON(statsRaw.tMin)
      : undefined,
    maxWallLossPercent: statsRaw.maxWallLossPercent
      ? GeckoMeasurement.CreateFromJSON(statsRaw.maxWallLossPercent)
      : undefined,
    nominalThickness: statsRaw.nominalThickness
      ? GeckoMeasurement.CreateFromJSON(statsRaw.nominalThickness)
      : undefined,
  }
}

export function serializeRUGSectionStats(
  stats: RugSectionStats
): RugSectionStatsRaw {
  return {
    section: sectionToRaw(stats.section),
    minThicknesses: stats.minThicknesses.map((minimum) => {
      return serializeRUGSectionMinimum(minimum)
    }),
    averageThickness: stats.averageThickness.toJSON(),
    tMin: stats.tMin?.toJSON(),
    nominalThickness: stats.nominalThickness?.toJSON(),
    maxWallLossPercent: stats.maxWallLossPercent?.toJSON(),
  }
}

export function deserializeRUGSectionStats(
  statsRaw: RugSectionStatsRaw
): RugSectionStats {
  return {
    section: sectionFromRaw(statsRaw.section),
    minThicknesses: statsRaw.minThicknesses.map((minimum) => {
      return deserializeRUGSectionMinimum(minimum)
    }),
    averageThickness: GeckoMeasurement.CreateFromJSON(
      statsRaw.averageThickness
    ),
    tMin: statsRaw.tMin
      ? GeckoMeasurement.CreateFromJSON(statsRaw.tMin)
      : undefined,
    maxWallLossPercent: statsRaw.maxWallLossPercent
      ? GeckoMeasurement.CreateFromJSON(statsRaw.maxWallLossPercent)
      : undefined,
    nominalThickness: statsRaw.nominalThickness
      ? GeckoMeasurement.CreateFromJSON(statsRaw.nominalThickness)
      : undefined,
  }
}
